module.exports = __webpack_public_path__ + "./angie_f0450ce2b07c704b7e056de1496e75d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/angie.png
// module id = 417
// module chunks = 0